<template>
<div class="map-menu-wrap">
    <!--地图指标-->
    <div class="map-menu physics-wrap" v-if="colorSettingArray&&colorSettingArray.length>0">
        <div v-for="(item,index) in colorSettingArray" :key="index" :class="['physical-item',item.isChecked?'selected':'',item.itemName]"
            :data-key="item.itemName" :data-value="index">
            <div class='menu-item title' @click="selectedColorSetting(item)">{{item.name}}</div>
            <div class='menu-item icon-wrap' @click="showColorSettingDialog(item)"><i class='iconfont icon-set'>&#xe781;</i></div>
        </div>
        <!--故障视图-->
        <fault :pipelineFeatureArray="pipelineFeatureArray" :stationConfig="stationConfig" :pipelineConfig="pipelineConfig" :mainmap="mainmap" @openFaultData="openFaultData"></fault>
        <div class="physical-item properties" @click="openProperties">
            <div class="menu-item title">管道</div>
            <div class="menu-item icon-wrap">
                <i class="iconfont icon-set">&#xe7d0;</i>
            </div>
        </div>
    </div>
    <!--颜色设置对话框-->
    <el-dialog :visible.sync="colorDialog"
        width="40%"
        custom-class="sidebar-wrapper"
        :append-to-body="true"
        :show-close="false"
        :before-close="colorSettingClose">
        <!--颜色设置弹框-->
        <div class="setting-conent" v-if="currentColorSetting" ref="colorSettingDialog">
            <div  class="menu-wrap" style="font-size: 15px;color:#5B5B5B;margin-top: 5px">
                <div class="label">
                    <span>颜色板设置</span>
                    <span class="tip">({{currentColorSetting.name}})</span>
                </div>
                <span :class="['closecolor2',currentColorSetting.colorPiece==1?'disabled':'']" @click="secondColorBlock">颜色段2</span>
                <el-button class="getsection" @click="getDataSection">获取区间</el-button>
            </div>

            <div class="color-wrap">
                <div class="color_1 color-content" v-if="currentColorSetting.colorBlock[0]">
                    <div class="setting-item setting-first">
                        <div class="input-tag">颜色段</div>
                        <input id="rgb-num" class="input-rgb" type="number" v-model="currentColorSetting.colorBlock[0].colorSection" 
                            placeholder="RGB分段" autocomplete="off"/>
                    </div>
                    <div class="setting-item">
                        <div class="input-tag">上限值</div>
                        <input id="max-data" class="input-rgb" type="number" v-model="currentColorSetting.colorBlock[0].upperValue" 
                            placeholder="最大值" autocomplete="off"/>
                    </div>
                    <div class="setting-item">
                        <div class="input-tag">下限值</div>
                        <input id="min-data" class="input-rgb" type="number" v-model="currentColorSetting.colorBlock[0].lowerValue"
                             placeholder="最小值" autocomplete="off"/>
                    </div>
                </div>
                <div :class="['color_2','color-content',currentColorSetting.colorPiece==1?'disabled':'']" v-if="currentColorSetting.colorBlock[1]">
                    <div class="setting-item setting-first">
                        <div class="input-tag">颜色段</div>
                        <input id="rgb-num2" class="input-rgb rgb-num2" type="number" v-model="currentColorSetting.colorBlock[1].colorSection" 
                            placeholder="RGB分段" autocomplete="off"/>
                    </div>

                    <div class="setting-item">
                        <div class="input-tag">上限值</div>
                        <input id="max-data2" class="input-rgb max-data2" type="number" v-model="currentColorSetting.colorBlock[1].upperValue" 
                            placeholder="最大值" autocomplete="off"/>
                    </div>

                    <div class="setting-item">
                        <div class="input-tag">下限值</div>
                        <input id="min-data2" class="input-rgb min-data2" type="number" v-model="currentColorSetting.colorBlock[1].lowerValue"
                             placeholder="最小值" autocomplete="off"/>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex;flex-direction: row;" class="btn-array" slot="footer">
            <el-button class="btn btn-canel" @click="colorSettingCanel">取消</el-button>
            <el-button class="btn btn-ok" @click="colorSettingOK">确定</el-button>
        </div>
    </el-dialog>

    <!--管道属性显示框-->
    <div class="pipe-properties" v-if="propertiesDialog">
        <div class="title">
            <span class="character">管道属性面板</span>
            <div class="close" @click="closeProperties">
                <i class="iconfont icon-close">&#xe618;</i>
            </div>
        </div>
        <div class="content" v-if="pipeproperties">
            <el-table
                border
                header-cell-class-name="pro-header"
                class="table"
                :data="propertiesArray"
                max-height="500"
                @row-click="propertiesClick"
                :highlight-current-row="true"
                style="width: 100%">
                <el-table-column v-for="(value,name) in pipeproperties" :key="name"
                    :prop="name"
                    :label="value"
                    :class="name"
                >
                </el-table-column>
                
            </el-table>
        </div>
    </div>

</div>
</template>
<script>
/** 绘图相关 */
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import {createEmpty,extend as Extentd,getCenter} from 'ol/extent';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';

import Select from 'ol/interaction/Select';
import {click} from 'ol/events/condition';

// import Fill from 'ol/style/Fill';

import _debounce from "lodash/debounce"; // 函数防抖
import _find from "lodash/find"; // 数组遍历

/** 绘图相关结束 */

import {getPipelineTimingData,getUserSetting,pipelineRealDataByID,pipelinePropertyByNumber,getPipelineDataSection,getLayerByName} from "@api/map2d";

import Fault from "./Fault";

export default {
    name:"pipeline",
    props:["mainmap","pipelineConfig","stationConfig","pipelineLayerData"],
    data(){
        return {
            colorDialog:false, // 颜色设置对话框
            colorSettingArray:[], // 颜色配置数组
            currentColorSetting:null, //当前选中的颜色配置项

            pipelineFeatureArray:null, //管线的图层数据

            pipelineTimer:null, // 管线的定时器

            loading:null, // 加载中实例
            featureExtent:null, // 管线的范围

            pipelineAlarmData:null, // 管线报警数据
            pipelineAlarmLayer:null, // 管道报警图层

            globalConfig:null, // 获取全局配置

            propertiesDialog:false, // 管道属性面板
            propertiesArray:[], // 管道属性数组

            hightSource:null, // 管道高亮图层
        }
    },
    components:{
        fault:Fault
    },
    mounted(){
        // 获取各个配置项
        this.init_config();
    },
    computed:{
        // 当前数据库
        db(){
            return this.$store.getters.db;
        },
        pipeproperties(){
            let pipeproperties=this.globalConfig&&this.globalConfig.pipematerial?this.globalConfig.pipematerial:"";
            return pipeproperties;
        }
    },
    watch:{
        /**监听站点配置改变 */
        stationConfig:{
            handler:function(newValue){
                let patternName=newValue.pattern.name;
                if(patternName=="realtime"&&this.currentColorSetting){
                    // 获取管线的实时数据
                    this.getPipelineTimingData(this.currentColorSetting);
                    // 重启定时器
                    this.getPipeLineRealTiming();

                }
            },
            deep:true
        },
        /** 监听数据库改变 */
        db:{
            handler:function(){
               // 重新执行初始化工作
               this.init_config();
            },
            deep:true
        }
    },
    methods:{
        // 初始化配置
        async init_config(){
            // 获取管线图层数据,同步执行
            await this.getPipelinelayer();
            // 获取管线颜色配置
            let drawConfig=await getUserSetting("draw");
            // 如果没有相关的颜色配置选项，则不进行管道绘制
            if(drawConfig.status!=200||!drawConfig.content||Object.keys(drawConfig.content).length<=0){
                this.currentColorSetting=null; // 清空当前颜色设置
                this.colorSettingArray=[]; // 清空颜色设置数组
                // 触发管线加载完成事件
                // this.$emit("pipelineLoadComplete");
                return;
            }

            // 有管道颜色配置选项，则进行管道颜色的绘制
            this.colorSettingArray=drawConfig.content;
            // 遍历当前选中的颜色设置项
            for(let item of this.colorSettingArray){
                if(item.isChecked){
                    this.currentColorSetting=JSON.parse(JSON.stringify(item)); // 进行深度拷贝，避免源数据修改
                    break;
                }
            }
            // 触发选中的颜色状态更新方法,通知父组件及其他组件更新颜色设置
            this.$emit("colorSettingChange",this.currentColorSetting);

            // 获取管道的实时数据
            this.getPipelineTimingData(this.currentColorSetting);
 
            // 开启定时任务
            this.getPipeLineRealTiming();

            // 绑定鼠标事件，滑动显示管道上的实时数据
            this.mapMoveFun();

            // 地图点击事件，点击管线显示管线的属性
            this.mapClickFun();

            // 触发管线加载完成事件
            this.$emit("pipelineLoadComplete");

        },
        // 获取管线图层数据
        async getPipelinelayer(){
            let that=this;
            // await getPipelinelayer().then(data=>{
                let data=this.pipelineLayerData;
                // 判断是否数据正常
                if(!data||!data.features||data.features.length<=0){
                    return;
                }
                // 加载管线数据
                let geojsonFormat=new GeoJSON();
                let features=geojsonFormat.readFeatures(data);
                //将请求结果保存
                that.pipelineFeatureArray=features;

                //获取管线的实时数据
                // that.getLineRealTimeData();

                //绘制图层
                let vectorSource = new VectorSource({
                    format: new GeoJSON(),
                });
                vectorSource.addFeatures(features);
                let vector = new VectorLayer({
                    name:"pipeline_layer",
                    source: vectorSource,
                    zIndex:200,
                    minResolution:that.mainmap.getResolution(20),
                    maxResolution:that.mainmap.getResolution(10),
                    style:new Style({
                        stroke: new Stroke({
                            lineCap:"square",
                            width:4,
                            color:"rgb(0, 255, 204)"
                        })
                    })
                });
                // 将图层添加到底图上
                that.mainmap.addLayer(vector);

                //获取管线范围
                let extent=createEmpty();
                let featureArray=features;
                for(let i=featureArray.length-1;i>=0;i--){
                    let feature=featureArray[i];
                    //存储图形的范围
                    let geom=feature.getGeometry();
                    extent=Extentd(extent,geom.getExtent());
                }
                //保存图形范围
                that.featureExtent=extent;
                // 输出中心坐标
                console.log((extent[0]+extent[2])/2,(extent[1]+extent[3])/2);

                let [x1,y1,x2,y2]=extent;
                that.featureExtent=[x1-0.01,y1-0.01,x2+0.01,y2+0.01];
                //图形缩放到全屏
                that.mainmap.getView().fit(that.featureExtent,that.mainmap.getSize());

            // });
        },
        // 定时获取管线的实时数据
        getPipeLineRealTiming:function(){
            let that=this;

            // 取消定时器
            if(that.pipelineTimer){
                clearTimeout(that.pipelineTimer);
                that.pipelineTimer=null;
            }
            // 判断当前路由是否为智慧管网，如果不是，则应该取消定时器
            if(this.$route.name!="mapShow"){
                return;
            }
            if(!that.pipelineTimer){
                that.pipelineTimer=setTimeout(function () {
                    if(that.stationConfig&&that.stationConfig.pattern){
                        let patternName=that.stationConfig.pattern.name;
                        if(patternName=="realtime"){
                            //执行获取管线实时数据以及绘制的代码
                            that.getPipelineTimingData(that.currentColorSetting);

                            // 重启定时任务
                            that.getPipeLineRealTiming();
                        }else {
                            clearTimeout(that.pipelineTimer);
                            that.pipelineTimer=null;
                        }
                    }
                },30*1000);
            }
        },
        // 获取管线的实时颜色数据
        getPipelineTimingData(currentColorSetting){
            let that=this;
            currentColorSetting=currentColorSetting||this.currentColorSetting;

            if(!currentColorSetting){ // 颜色配置不存在
                return;
            }

            // 去掉不需要的字段
            let colorSetting={
                id:currentColorSetting.id,
                itemName:currentColorSetting.itemName,
                name:currentColorSetting.name,
                isChecked:currentColorSetting.isChecked,
                colorPiece:currentColorSetting.colorPiece,
                colorBlock:[{
                    colorSection: currentColorSetting.colorBlock[0].colorSection,
                    upperValue: currentColorSetting.colorBlock[0].upperValue,
                    colorType:currentColorSetting.colorBlock[0].colorType,
                    lowerValue: currentColorSetting.colorBlock[0].lowerValue
                },{
                    colorSection: currentColorSetting.colorBlock[1].colorSection,
                    upperValue: currentColorSetting.colorBlock[1].upperValue,
                    colorType:currentColorSetting.colorBlock[1].colorType,
                    lowerValue: currentColorSetting.colorBlock[1].lowerValue
                }]
            }
            // 获取管线的实时数据
            getPipelineTimingData(JSON.stringify(colorSetting)).then(data=>{
                // 关闭loading
                if(this.loading){
                    this.loading.close();
                }

                //如果没有数据
                if(!data||(data.status&&data.status!=200)){
                    return;
                }

                //管线提示信息
                // let PipeTips=data.PipeTips;
                // let $pipeTips=$(".pipetips");
                // if(PipeTips){
                //     $pipeTips.show();
                //     $pipeTips.find(".title").html(PipeTips.Title);
                //     $pipeTips.find(".content").html(PipeTips.Text.replace(/\\n/g,"<br>"));
                // }else{
                //     $pipeTips.hide();
                // }

                //管线信息
                let PipePointItem=data.PipePointItem;
                
                 //管线更新时间
                if(PipePointItem&&PipePointItem.UpdateTime){
                    var updateTime=PipePointItem.UpdateTime;
                    //添加实时时间标签
                    let realtimeDom=document.querySelector(".simulation-wrap .realtime-wrap");
                    // 没有实时标签，就可能已经没有在当前页面了，所以直接停止下面的逻辑
                    if(realtimeDom){
                        realtimeDom.innerHTML=updateTime;
                        realtimeDom.style.display="block";

                        // 清除DOM引用，防止内存泄漏
                        realtimeDom=null;
                    }else{
                        // 清除DOM引用，防止内存泄漏
                        realtimeDom=null;
                        return;
                    }

                }
                // 管道的报警数据
                /**
                 * PipePointAlarm=[{
                 *  start:0,
                 *  end:10,
                 *  text:"报警",
                 *  features:[]
                 * }]
                 */
                let pipelineAlarmData=data.PipePointAlarm;
                // 为了测试
                // pipelineAlarmData=[{
                //     "start":0,
                //     "end":100,
                //     "text":"这段要报警"
                // }]
                this.pipelineAlarmData=pipelineAlarmData; // 保存管线报警数据

                // 管线的计算数据
                data=data.PipePointData;
                //遍历所有的线段,获取线段编号，然后根据线段编号从线段配置文件中读取相应的数据，根据起始和终点相减获取到数据长度，然后在实时数据中取相应的长度数据对应
                let featureArray=that.pipelineFeatureArray;
                for(let i=featureArray.length-1;i>=0;i--){
                    let feature=featureArray[i];

                    let featureProperties=feature.getProperties();
                    // 获取线段编号,属性字段可能为number或者是Number
                    let linenumber=featureProperties.number||featureProperties.Number;
                    // 管线配置不存在
                    if(!that.pipelineConfig){
                        break;
                    }
                    let lineConfig=that.pipelineConfig[linenumber];
                    //如果线段中有配置项，则根据配置项进行绘制
                    if(lineConfig){
                        // 子编号在线段的配置文件里面，则获取数据，属性信息可能为subnumber或者是SubNumber
                        let subNumber=featureProperties.subnumber||featureProperties.SubNumber;
                        let sublineArray=lineConfig.sublineArray;
                        for(let j=sublineArray.length-1;j>=0;j--){
                            let subLineConfig=sublineArray[j];
                            let startNumber=subLineConfig.startIndex;
                            let endNumber=subLineConfig.endIndex;
                            if(subNumber>=startNumber&&subNumber<=endNumber){
                                // 获取每一段地图上的管线对应的管线实时数据的偏移量
                                // 偏移量=当前线段的子编号-线段配置文件中的开始编号+线段配置文件中的数据开始偏移量
                                let offsetIndex=subNumber-startNumber+subLineConfig.dindex;
                                let realData=data[offsetIndex];
                                realData.updateTime=updateTime;

                                //获取到真实数据后，根据数据绘制内容
                                feature.set("realdata",realData);
                                feature.setStyle(that.pipelineStyleFun(feature));

                                // 查找feature是否处于报警范围内
                                if(pipelineAlarmData){
                                    let alarm=_find(pipelineAlarmData,function(o){
                                        return offsetIndex>=o.start&&offsetIndex<=o.end;
                                    });
                                    // 如果该节点处于报警区间内
                                    if(alarm){
                                        alarm.features=alarm.features||[];
                                        alarm.features.push(feature);
                                    }
                                }
  
                            }
                        }
                    }
                }
                // 生成管线报警图层
                if(that.pipelineAlarmData){
                    that.createPipelineAlarmLayer();
                }
            });
        },

        //绘制管线样式
        pipelineStyleFun(feature) {
             let featureProperties=feature.getProperties();
            //根据当前配置项，显示数据
            let currentColorSetting=this.currentColorSetting;
            let realDataType=currentColorSetting.itemName;
            let isChecked=currentColorSetting.isChecked;
            if(!featureProperties.realdata||!featureProperties.realdata[realDataType]||!isChecked){
                return ;
            }
            // 当前实时数据的颜色值
            let currentValue=featureProperties.realdata[realDataType];

            let style=new Style({
                stroke: new Stroke({
                    color: currentValue,
                    width:4,
                    lineCap:"square"
                })
            });
            return style;
        },
        // 管道报警图层
        createPipelineAlarmLayer(){
            // console.log(this.pipelineAlarmData);
            // 生成报警图层
            if(!this.pipelineAlarmLayer){
                //绘制图层
                let vectorSource = new VectorSource();
                // 报警图层
                let vector = new VectorLayer({
                    name:"pipelinealarm_layer",
                    source: vectorSource,
                    zIndex:300,
                    minResolution:this.mainmap.getResolution(20),
                    maxResolution:this.mainmap.getResolution(10),
                    style:new Style({
                        stroke: new Stroke({
                            color: 'red',
                            width: 0.8
                        }),
                        // fill: new Fill({
                        //     color: 'rgba(255, 255, 255, 0.01)',
                        // }),
                    }),
                });
                // 将图层添加到底图上
                this.mainmap.addLayer(vector);
                // 保存图层内容
                this.pipelineAlarmLayer=vector;
            }
            // 获取图层数据源
            let vectorSource=this.pipelineAlarmLayer.getSource();

            // 遍历报警数组,根据其中的features数组，获取最大和最小的坐标，生成相应的范围
            let dcount=this.pipelineAlarmData.length;
            for(let i=dcount-1;i>=0;i--){
                let alarmItem=this.pipelineAlarmData[i];
                let features=alarmItem.features;
                let fcount=features.length;
                let featureExtent=createEmpty(); // 创建一个空的范围
                for(let j=fcount-1;j>=0;j--){
                    let feat=features[j];
                    let gemo=feat.getGeometry();
                    let gemoExtent=gemo.getExtent();
                    // 创建一个包围框，将所有报警范围内的图形都圈起来
                    featureExtent=Extentd(featureExtent,gemoExtent);
                }
                // 保存外包络矩形
                alarmItem.extent=featureExtent;

                // 根据外包络矩形，创建包围框
                let outsourcing=new Feature({
                    geometry: new Polygon([[[featureExtent[0],featureExtent[1]],[featureExtent[0],featureExtent[3]],
                        [featureExtent[2],featureExtent[3]],[featureExtent[2],featureExtent[1]]]])
                });
                // 添加到图层中
                vectorSource.addFeature(outsourcing);
            }

        },

        // 不点击取消按钮关闭对话框
        colorSettingClose(){
            this.colorDialog=false; // 站点设置对话框关闭    
        },
        // 颜色设置对话框取消
        colorSettingCanel(){
            this.$confirm('您的操作还没有保存, 是否继续修改?', '温馨提示', {
                confirmButtonText: '继续修改',
                cancelButtonText: '确定取消',
                type: 'warning'
            }).catch(() => {
                this.colorDialog=false; // 站点设置对话框关闭    
            });
        },
        // 颜色设置对话框确定按钮
        colorSettingOK(){
            // 获取各个设置框的值


            // 遍历颜色设置数组，将当前的设置保存到设置数组中
            for(let item of this.colorSettingArray){
                if(item.itemName==this.currentColorSetting.itemName){
                    item.isChecked=true;
                    item.colorPiece=this.currentColorSetting.colorPiece;
                    // 修改颜色段的设置
                    item.colorBlock=JSON.parse(JSON.stringify(this.currentColorSetting.colorBlock));
                }else{
                    item.isChecked=false;
                }
            }


            // 请求管线的实时值
            this.getPipelineTimingData(this.currentColorSetting);

            // 触发选中的颜色状态更新方法,通知父组件及其他组件更新颜色设置
            this.$emit("colorSettingChange",this.currentColorSetting);

            // 关闭对话框
            this.colorDialog=false;
        },
        // 第二段颜色设置打开和关闭
        secondColorBlock(){
            if(this.currentColorSetting.colorPiece==1){
                this.currentColorSetting.colorPiece=2;
            }else{
                this.currentColorSetting.colorPiece=1;
            }
        },

        // 显示颜色设置对话框
        showColorSettingDialog(item){
            // 选中当前设置项,进行深度拷贝，避免操作源数据
            this.currentColorSetting=JSON.parse(JSON.stringify(item));
            // 显示对话框
            this.colorDialog=true;
        },
        // 菜单栏选择当前颜色设置
        selectedColorSetting(item){
            // 遍历全部的颜色设置，取消选中
            for(let it of this.colorSettingArray){
                if(it.itemName!=item.itemName){
                    it.isChecked=false;
                }else{
                    it.isChecked=true;
                }
            }
            item.isChecked=true;

            // 设置当前选中菜单项
            this.currentColorSetting=item;

            // 触发选中的颜色状态更新方法,通知父组件及其他组件更新颜色设置
            this.$emit("colorSettingChange",this.currentColorSetting);

            // 如果从故障视图切换过来的,需要重置模式为实时模式
            if(this.stationConfig.pattern.name=="fault"){
                this.$set(this.stationConfig.pattern,"name","realtime");
            }

            // 判断当前计算模式
            if(this.stationConfig.pattern.name=="realtime"){
                // 显示加载中
                this.loading=this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                // 清空定时器
                if(this.pipelineTimer){
                    clearTimeout(this.pipelineTimer);
                    this.pipelineTimer=null;
                }
                // 自动获取区间值
                this.getDataSection("auto");

                // // 请求管线的实时值
                // this.getPipelineTimingData(item);
                // // 重启定时任务
                // this.getPipeLineRealTiming();
            }            
        },

        // 鼠标移动查询管道数据
        mapMoveFun(){
            let that=this;
            // 判断是否有颜色配置，如果没有颜色配置，则不需要进行鼠标查询绑定
            if(!that.currentColorSetting||!that.colorSettingArray||that.colorSettingArray.length<=0){
                return;
            }

            // 绑定鼠标移动事件，鼠标移动到相应的管线上弹出属性信息
            that.mainmap.on("pointermove",_debounce(function(event){
                let zoom=that.mainmap.getView().getZoom();
                if(zoom<=14){
                    return;
                }
                //关闭管线属性
                let overlayPipeline=that.mainmap.getOverlayById("pipeline_data");
                if(overlayPipeline){
                    overlayPipeline.setPosition(undefined);
                }
                //关闭站点属性
                let overlayStation=that.mainmap.getOverlayById("pointer_station");
                if(overlayStation){
                    overlayStation.setPosition(undefined);
                }
                // 变量获取到的feature
                let pixel=event.pixel;
                that.mainmap.forEachFeatureAtPixel(pixel,function (feature,layer) {
                    let layerName=layer.get("name");
                    if(feature){
                        switch(layerName){
                            case "pipeline_layer": // 管道图层
                                // 后台获取数据，鼠标滑动事件
                                that.pipelineRealData(feature);
                                break;
                        }
                    }
                    return feature;
                });
            },500));
        },
        // 后台获取数据解析相关管线上的数据
        pipelineRealData(feature){
            let featureProperty=feature.getProperties();
            let lineId=featureProperty.number||featureProperty.Number;
            let subIndex=featureProperty.subnumber||featureProperty.SubNumber;
            if(!featureProperty.realdata){
                return;
            }
            let updateTime=featureProperty.realdata.updateTime;

            let that=this;
            // 获取当前的模式
            let pattern=that.stationConfig.pattern;
            let patternName=pattern.name;
            let similationValue="";
            if(patternName=="simulation"){
                let stationDefault=that.stationConfig.pattern.stationDefault;
                let patternValueArray=[];
                for(let key in stationDefault){
                    let temp=stationDefault[key];
                    patternValueArray.push(temp);
                }
                let val=JSON.stringify(patternValueArray);
                val=val.replace(/InsFlux/g,"FlowMass");
                similationValue="{\"CalcPipeInput\":"+val+"}";
            }
            // 请求后台数据，获取管线信息
            pipelineRealDataByID(lineId,subIndex,patternName,similationValue).then(data=>{
                if(!data||(data.status&&data.status!=200)){
                    return;
                }
                let realData=data.content;
                // 如果存在实时数据，则显示实时数据的内容
                if(realData){
                    //获取当前颜色及物理项的配置选项,里面保存了要显示的物理项内容和名字
                    let physical=that.colorSettingArray;
                    let physicalCount=physical.length;

                    let itemHtml="";
                    //物理量时间：
                    if(updateTime){
                        itemHtml="<li class='time'>时间："+updateTime+"</li>";
                    }

                    for(let i=0;i<physicalCount;i++){
                        let physicalValue=physical[i];
                        if(realData[physicalValue.itemName]){
                            itemHtml+="<li class='"+physicalValue.itemName+"'>"+physicalValue.name+"："+parseFloat(realData[physicalValue.itemName]).toFixed(4)+"</li>"
                        }
                    }
                    let overlay=that.mainmap.getOverlayById("pipeline_data");
                    let overlayDom=null;
                    if(!overlay){
                        overlayDom=document.createElement("div");
                        overlayDom.className="ztOverlay pipelineproperty";

                        let innerHTML="<div class='zt-title'>" +
                            "</div>"+
                            "<ul class='ztOverlay_content'>"+
                                itemHtml+
                            "</ul>";
                        overlayDom.innerHTML=innerHTML;

                        overlay = new Overlay({
                            id:"pipeline_data",
                            element: overlayDom,
                            positioning:"bottom-center",
                            offset:[0,-10],
                            // stopEvent:false
                        });
                        //overlay.setId("pipeline_label");
                        that.mainmap.addOverlay(overlay);
                    }
                    let overlayHtml=overlay.getElement();
                    // 设置最上方
                    overlayHtml.style.zIndex=110001;
                    overlayHtml.parentNode.style.zIndex=1;
                    overlayHtml.style.display="block";

                    overlayHtml.querySelector(".ztOverlay_content").innerHTML=itemHtml;
                    // 获取geom中点位置
                    let geom=feature.getGeometry();
                    let coordinate=getCenter(geom.getExtent());
                    overlay.setPosition(coordinate);
                }
            });
        },
        // 地图点击交互事件
        async mapClickFun(){            
            // 获取全局配置
            if(!this.globalConfig){
                let res=await getUserSetting("others");
                if(res&&res.status==200){
                    this.globalConfig=res.content;
                }
                
            }
            // 获取管道属性图层
            let data=await getLayerByName(this.db.dburlname,"pipematerial");
            try{
                let geojsonFormat=new GeoJSON();
                let features=geojsonFormat.readFeatures(data);
                // 遍历features，生成属性数组
                let propertiesArray=[];
                for(let feature of features){
                    let props=feature.getProperties();
                    // 保存关于feature的引用
                    props.feature=feature;
                    // 构建数组
                    propertiesArray.push(props);
                }
                this.propertiesArray=propertiesArray;
                
                //绘制图层
                let vectorSource = new VectorSource({
                    name:"pipematerial_source",
                    format: new GeoJSON(),
                });
                vectorSource.addFeatures(features);
                let vector = new VectorLayer({
                    source: vectorSource,
                    name:"pipematerial_layer",
                    zIndex:20,
                    minResolution:this.mainmap.getResolution(20),
                    maxResolution:this.mainmap.getResolution(12),
                    style:new Style({
                        stroke: new Stroke({
                            color: 'rgba(0, 0, 255, 0.9)',
                            width: 3,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.9)',
                        }),
                    }),
                });

                this.mainmap.addLayer(vector);

                // 高亮图层，因为管道属性在管道温压的下层，
                // 所以选中的时候，可能无法进行高亮，所以就添加了一个单独的高亮图层，在管道的上层
                let hightSource=new VectorSource({
                    name:"pipematerial_source_hight",
                });
                let hightVector = new VectorLayer({
                    source: hightSource,
                    name:"pipematerial_layer_hight",
                    zIndex:20000,
                    minResolution:this.mainmap.getResolution(20),
                    maxResolution:this.mainmap.getResolution(12),
                    style:new Style({
                        stroke: new Stroke({
                            color: 'rgba(0, 0, 255, 0.9)',
                            width: 3,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.9)',
                        }),
                    }),
                });
                this.mainmap.addLayer(hightVector);
                this.hightSource=hightSource;

                //鼠标点击管线查询管线属性
                let that=this;
                const selectClick = new Select({
                    condition: click,
                    layers:[
                        vector
                    ],
                    hitTolerance:10
                });

                this.mainmap.addInteraction(selectClick);

                selectClick.on("select",(event)=>{
                    let zoom=that.mainmap.getView().getZoom();
                    // 地图过小的时候不显示相关信息
                    if(zoom<=14){
                        return;
                    }
                    //关闭管线属性
                    let overlayPipeline=that.mainmap.getOverlayById("pipeline_data");
                    if(overlayPipeline){
                        overlayPipeline.setPosition(undefined);
                    }
                    //关闭站点属性
                    let overlayStation=that.mainmap.getOverlayById("pointer_station");
                    if(overlayStation){
                        overlayStation.setPosition(undefined);
                    }

                    let feature=event.selected[0];

                    // 清空高亮图层
                    hightSource.clear();
                    // 显示管道属性
                    if(feature){
                        // 显示管道属性
                        that.pipelineProperty(feature);
                        // 高亮显示
                        hightSource.addFeature(feature);
                    }else{ // 查看属性信息框是否显示，如果显示了，则不应该清除高亮
                        let overlay=that.mainmap.getOverlayById("pipelineproperty");
                        if(overlay){
                            // 清空高亮图层
                            feature=event.deselected[0];
                            hightSource.addFeature(feature);
                        }
                    }
                    
                });

            }catch(err){
                console.log("ERROR:Valve:getLayer:获取图层失败");
            }
        },
        //获取区间值
        getDataSection:function(mode){
            var that=this;

            let currentColorSetting=this.currentColorSetting;
            var itemname=currentColorSetting.itemName;
            var maxdata2=0;

            // 如果是自动获取区间值
            if(mode&&mode=="auto"){
                // 判断颜色段
                let colorPiece=currentColorSetting.colorPiece;
                if(colorPiece==2){
                    maxdata2=currentColorSetting.colorBlock[1]?currentColorSetting.colorBlock[1].upperValue:0;
                }else{
                    maxdata2=currentColorSetting.colorBlock[0].lowerValue;
                }
            }else{
                // 获取当前选中的项目
                let $el=document;
                var $sidebarWrapper=$el.querySelector(".sidebar-wrapper");
                if($sidebarWrapper){
                    var color2=$sidebarWrapper.querySelector(".color_2");
                    // 获取第二段的最大值，为了传回后台，计算出比第一段中，比第二段的最大值小的数
                    maxdata2=color2.querySelector(".max-data2").value||0;
                }

                // 清除Dom引用
                $el=null;
                $sidebarWrapper=null;

            }
            //获取当前模式
            var pattern=that.stationConfig.pattern;
            var patternName=pattern.name;
            var simulationValue="";
            if(patternName=="simulation"){
                var stationDefault=pattern.stationDefault;
                var patternValueArray=[];
                for(var key in stationDefault){
                    var temp=stationDefault[key];
                    patternValueArray.push(temp);
                }
                var val=JSON.stringify(patternValueArray);
                val=val.replace(/InsFlux/g,"FlowMass");
                simulationValue="{\"CalcPipeInput\":"+val+"}";
            }

            // 请求后台获取数据区间
            getPipelineDataSection(itemname,maxdata2,simulationValue).then(data=>{
                if(!data&&data.status!=200){
                    return;
                }
                // 得到区间
                var content=data.content;
                var minValue=parseFloat(content.minValue).toFixed(3);
                var maxValue=parseFloat(content.maxValue).toFixed(3);
                var midValue=content.midValue;

                let colorBlock1=that.currentColorSetting.colorBlock[0]; // 第一段颜色
                let colorBlock2=that.currentColorSetting.colorBlock[1]; // 第二段颜色
                
                // color1.querySelector("#max-data").value=maxValue;
                colorBlock1.upperValue=maxValue;

                // 如果是自动获取区间模式
                if(mode&&mode=="auto"){
                    // 判断颜色段
                    let colorPiece=currentColorSetting.colorPiece;
                    if(colorPiece==2){
                        maxdata2=currentColorSetting.colorBlock[1]?currentColorSetting.colorBlock[1].upperValue:0;
                        //如果是两段颜色的情况，需要获取最小值，将最小值设置到第二段的下限值，第一段的下限值为大于第二段上限值的最小值
                        if(maxdata2>=minValue){
                            // color2.querySelector("#min-data2").value=minValue; //设置第二段最小值为全部最小值
                            colorBlock2.lowerValue=minValue;
                        }else{
                            // color2.querySelector("#min-data2").value=0;
                            colorBlock2.lowerValue=0;
                        }
            
                        //获取第一个比第二段上限值大的数字
                        minData1=parseFloat(midValue).toFixed(3);
                        // color1.querySelector("#min-data").value=minData1;
                        colorBlock1.lowerValue=minData1;
                    }else{
                        colorBlock1.lowerValue=minValue;
                    }
                    // console.log(currentColorSetting);
                    // 更新
                    this.currentColorSetting=Object.assign({},currentColorSetting);
                    // 修改颜色区间
                    this.colorSettingOK();
                    // 请求管线的实时值
                    // this.getPipelineTimingData(currentColorSetting);
                    // 重启定时任务
                    this.getPipeLineRealTiming();
                }else{
                    let $el=document;
                    var $sidebarWrapper=$el.querySelector(".sidebar-wrapper");
                    var color2=$sidebarWrapper.querySelector(".color_2");
                    if(!color2.classList.contains("disabled")&&color2.querySelector("#rgb-num2").value>0&&colorBlock2){  //如果是两段的情况
                        var maxdata2=color2.querySelector(".max-data2").value;
            
                        //如果是两段颜色的情况，需要获取最小值，将最小值设置到第二段的下限值，第一段的下限值为大于第二段上限值的最小值
                        if(maxdata2>=minValue){
                            // color2.querySelector("#min-data2").value=minValue; //设置第二段最小值为全部最小值
                            colorBlock2.lowerValue=minValue;
                        }else{
                            // color2.querySelector("#min-data2").value=0;
                            colorBlock2.lowerValue=0;
                        }
            
                        //获取第一个比第二段上限值大的数字
                        var minData1=parseFloat(midValue).toFixed(3);
                        // color1.querySelector("#min-data").value=minData1;
                        colorBlock1.lowerValue=minData1;


                    }else {  //如果是一段的情况
                        // color1.querySelector("#min-data").value=minValue;
                        colorBlock1.lowerValue=minValue;
                    }

                    // 清除Dom引用
                    $el=null;
                    $sidebarWrapper=null;
                    color2=null;
                }

                
            });
        },

        //后台获取管线的属性信息
        pipelineProperty:function(feature){
            let properties=feature.getProperties();
            let that=this;
            if(properties){
                //关闭颜色显示
                let overlay=that.mainmap.getOverlayById("pipeline_data");
                if(overlay){
                    overlay.setPosition(undefined);
                }

                //管线字段说明
                let pipelineProperty=this.globalConfig.pipematerial;
                
                if(!pipelineProperty){
                    return;
                }
                // 遍历属性信息
                let itemHtml="";
                for(let itemname in properties){
                    if(pipelineProperty[itemname]){
                        itemHtml+="<li class='"+itemname+"'>"+pipelineProperty[itemname]+"："+properties[itemname]+"</li>"
                    }
                }
                // 显示属性信息框
                overlay=that.mainmap.getOverlayById("pipelineproperty");
                let overlayDom=null;
                if(!overlay){
                    overlayDom=document.createElement("div");
                    overlayDom.className="ztOverlay pipelineproperty property";

                    let innerHTML= "<div class='zt-title'>" +
                            '<div class="zt-close"><i class="iconfont">&#xe618;</i></div>'+
                        "</div>"+
                        "<ul class='ztOverlay_content'>"+
                            itemHtml+
                        "</ul>";
                    overlayDom.innerHTML=innerHTML;

                    overlay =new Overlay({
                        id:"pipelineproperty",
                        element: overlayDom,
                        positioning:"bottom-center",
                        offset:[0,-10],
                        stopEvent:false
                    });


                    that.mainmap.addOverlay(overlay);
                    overlayDom.querySelector(".zt-close").addEventListener("click",function () {
                        // 关闭显示
                        let overlay=that.mainmap.getOverlayById("pipelineproperty");
                        if(overlay){
                            overlay.setPosition(undefined);
                        }

                        // 清空高亮图层
                        that.hightSource.clear();
                    })
                }
                let overHtml=overlay.getElement();
                overHtml.style.zIndex=110001;
                overHtml.style.display="block";
                overHtml.parentNode.parentNode.style.zIndex=1;

                overHtml.querySelector(".ztOverlay_content").innerHTML=itemHtml;
                // 获取geom中点位置
                let geom=feature.getGeometry();
                let coordinate=getCenter(geom.getExtent());
                overlay.setPosition(coordinate);
            }
        },
        // 故障视图打开
        openFaultData(){
            // 关闭颜色按钮
            for(let it of this.colorSettingArray){
                it.isChecked=false;
            }
        },
        // 打开属性表
        openProperties(){
            this.propertiesDialog=true;
        },
        // 关闭属性表
        closeProperties(){
            this.propertiesDialog=false;
            // 高亮显示
            let layer=this.mainmap.getLayerByName("pipematerial_layer_hight");
            if(layer){
                let s=layer.getSource()
                s.clear();
            }
        },
        // 选中某一管段
        propertiesClick(row){
            // 缩放到图形
            let geom=row.geometry;
            let ext=geom.getExtent();
            this.mainmap.getView().fit(ext);
            // 高亮显示
            let layer=this.mainmap.getLayerByName("pipematerial_layer_hight");
            if(layer){
                let s=layer.getSource()
                s.clear();
                s.addFeature(row.feature);
            }
        }
    }
}
</script>
<style lang="scss">
/**颜色段设置*/
.sidebar-wrapper{
    border-radius: 20px;
    overflow: hidden;

    .setting-conent{
        padding:20px 20px 5px 20px;
        // width: 345px;
    }
    .setting-conent .physics-wrap{
        flex-wrap:wrap;
    }
    .setting-conent .physics-wrap:after {
        content: "";
        flex: auto;
    }
    .setting-conent .physical-item{
        padding:10px 20px;
        font-size:15px;
        cursor: pointer;
        border-radius: 10px;
        margin:10px;
        border:1px solid #E3E3E3;
    }
    .setting-conent .physical-item.selected{
        border:1px solid #1E9FFF;
    }
    .color-wrap{
        display: flex;
        width: 100%;
    }
    .setting-conent .color-content.color_2{
        // display: none;
    }
    .setting-conent .color-content.disabled{
        color:#aaa;

        input{
            color:#aaa;
        }
    }
    .menu-wrap .label{
        display: inline-block;
        .tip{
            font-size: 12px;
            color:red;
            margin-left: 10px;
        }
    }
    .menu-wrap .disabled{
        border:1px solid #666666;
        color:#666666;
    }
    .colorbar .colorbar-tip-wrap{
        height: 300px;
    }

    .colorbar .colorbar-tip-wrap{
        position: relative;
        position: relative;
        width: 70px;
        top: 0px;
        height: 150px;
        background: rgba(0,0,0,0.4);
        display: inline-block;
    }
    .colorbar .colorbar-item{
        display: inline-block;
    }
    .colorbar .colorbar-tip{
        display: flex;
        justify-content: flex-end;
        padding-right:4px;
        align-items: center;
        font-size: 12px;
        width: 70px;
        position: absolute;
    }

    .setting-conent .color-content{
        display: inline-block;
        flex: 1;
    }
    .setting-item{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 5px;
    }

    .setting-item input{
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(0,0,0,.2);
        margin-bottom: 15px;
        padding: 10px 15px;
        outline: 0;
        background-color: #fff;
        -webkit-appearance: none;
    }

    /*获取区间*/
    .getsection,.closecolor2{
        display: inline-block;
        border-radius: 5px;
        padding: 5px 10px;
        margin-top: -5px;
        cursor: pointer;
        font-size:14px;
        margin-right: 5px;
        float: right;
    }
    .getsection{
        padding:6px 10px;
        border:none;
    }
    .closecolor2{
        border:1px solid #1E9FFF;
    }

    .setting-first{
        margin-top:20px;
    }
    .setting-item .input-tag,.setting-item .input-rgb{
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        width: 60px;
    }
    .setting-item .input-tag{
        text-align: center;
        margin-top:-15px;
    }

    .btn{
        width: 100%;
        height: 50px;
        border: none;
        cursor: pointer;
    }
    .btn-ok{
        background:#3086FF;
        color:#fff;
    }

    /**重定义element-ui的样式 */
    .el-dialog__header{
        padding:10px;
    }
    .el-dialog__body{
        padding:0 20px;
    }
    .el-dialog__footer{
        padding:10px 0 0 0;
    }
    .el-button{
        margin-left: 0;
        line-height: initial;

        span{
            cursor: pointer;
        }
    }
}
/**颜色段设置结束*/

/* 地图菜单 */
.map-menu-wrap{
    background-color: #fff;
    line-height: 60px;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid #9d9898;

    .map-menu{
        position: relative;
        z-index: 11;
        background: #fff;
        display: inline-block;
        width: 80%;
        margin-left: 10px;

        .menu_icon{
            display: inline-block;
            width: 40px;
            height: 40px;
            z-index: 10;
            cursor: pointer;
            margin-left: 5px;
        }
        .menu-item{
            display: inline-block;
            width: 50px;
        }
        .icon-wrap{
            width: 30px;
        }
        .physical-item{
            display:inline-block;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            border: 1px solid #fff;
            padding: 0 5px;
        }
        .physical-item:hover{
            color: #0588ec;
        }
        .physical-item.selected{
            border:1px solid #1E9FFF;
            color:#1E9FFF;
        }
    }
}
/** 地图菜单 */

/**管道属性显示框 */
.pipe-properties{
    position: fixed;
    top: 130px;
    min-width: 200px;
    min-height: 100px;
    max-width: 600px;
    background: rgba(255, 255, 255, 0.8);
    line-height: initial;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #aaa;

    .title{
        font-size: 13px;
        border-bottom: 1px solid #E3E3E3;
        padding-bottom: 5px;

        .close{
            float:right;
            cursor: pointer;
        }
    }

    .content{
        padding-top: 5px;
        .table{
            .pro-header{
                text-align: center;
            }
        }
    }
}

</style>